import * as THREE from 'three'
import Experience from '../Experience'

export default class Fog {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene

    this.createFog()
  }

  createFog() {
    const fog = new THREE.Fog('#2D222B', 60, 80)
    this.scene.fog = fog
  }

  update() {}
}
